import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { FC } from 'react';
import config from '~/config';

export const Footer: FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box sx={{ backgroundColor: '#281932', color: '#fff' }}>
      <Box sx={{ maxWidth: '1200px', margin: 'auto', paddingY: { xs: 3, md: 8 }, paddingX: { xs: 3, md: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Typography variant="body2" display={{ xs: 'block', md: 'inline' }}>
              {`${currentYear} CUB. All Rights Reserved`}
            </Typography>
            <Typography variant="body2" display={{ xs: 'none', md: 'inline' }}>
              {' - '}
            </Typography>
            <Typography variant="body2" display={{ xs: 'block', md: 'inline' }}>
              {config.CUB_MAIN_DOCUMENT}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            justifyContent={{ xs: 'left', md: 'right' }}
            display={{ xs: 'flex', md: 'flex' }}
          ></Grid>
          <Grid item xs={12} md={5} display={{ xs: 'flex', md: 'flex' }}>
            <Typography variant="body2">
              Para mais informações sobre segurança, acesse o
              <a
                target="_blank"
                href="https://www.cub.com.br/termo-privacidade-cub.html"
                style={{ color: 'white', marginLeft: '5px', marginRight: '5px' }}
              >
                {'Termo de privacidade'}
              </a>
              da plataforma CUB.
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography variant="body2">{config.CUB_ADDRESS}</Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography variant="body2">{config.CUB_ADDRESS_TWO}</Typography>
          </Grid>
          <Grid item xs={12} md={12} marginTop={2}>
            <Typography marginBottom={2} variant="body2" fontWeight="bold">
              Nossos parceiros e investidores
            </Typography>
            <Box display="block">
              <Box
                component="img"
                sx={{
                  height: '48px',
                  marginRight: 3,
                  display: { xs: 'block', md: 'inline' },
                }}
                alt="Logo Inovabra"
                src={'/supporter_inovabra.png'}
              />
              <Box
                component="img"
                sx={{
                  height: '48px',
                  marginRight: 3,
                  display: { xs: 'block', md: 'inline' },
                }}
                alt="Logo Graphene"
                src={'/supporter_graphene.png'}
              />
              <Box
                component="img"
                sx={{
                  height: '48px',
                  marginRight: 3,
                  display: { xs: 'block', md: 'inline' },
                }}
                alt="Logo Terracota"
                src={'/supporter_terracota.png'}
              />
              <Box
                component="img"
                sx={{
                  marginY: '9px',
                  height: '30px',
                  marginRight: 3,
                  display: { xs: 'block', md: 'inline' },
                }}
                alt="Logo Aelo"
                src={'/supporter_aelo.png'}
              />
              <Box
                component="img"
                sx={{
                  marginY: { xs: '20px', md: '14px' },
                  height: '20px',
                  marginRight: 3,
                  display: { xs: 'block', md: 'inline' },
                }}
                alt="Logo Endeavor"
                src={'/supporter_endeavor.png'}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
